export default "__VITE_ASSET__5bcbcda1__"